export default __webpack_public_path__ + "static/media/group2.9222fca5.png";